import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import './index.css';
import './App.css';

const raiz = document.getElementById('raiz');
if (!raiz) throw new Error('Falta el contenedor #raiz en index.html.');

createRoot(raiz).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
